module.exports = __webpack_public_path__ + "img/photovoltaik-large.cab3446.webp";